import dayjs from 'utils/dayjs'

export default function dayDate(date) {
  return date ? dayjs(date).format('dddd, MMM D') : '–'
}
